var _style, _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamworkBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7BDAE2;}\n\t.st1{fill:#24C0CC;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_655",
    className: "st0",
    cx: 3.3,
    cy: 8.2,
    r: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_656",
    className: "st0",
    cx: 20.8,
    cy: 11.5,
    r: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_657",
    className: "st0",
    cx: 19.9,
    cy: 14.5,
    r: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-people-carry",
    className: "st1",
    d: "M8,9c0.6,0,1-0.5,1-1S8.6,7,8,7C7.5,7,7,7.4,7,8c0,0,0,0,0,0C7,8.6,7.5,9,8,9z  M16.1,9c0.6,0,1-0.5,1-1s-0.5-1-1-1c-0.6,0-1,0.5-1,1c0,0,0,0,0,0C15.1,8.6,15.6,9,16.1,9C16.1,9,16.1,9,16.1,9L16.1,9z M18.8,16.9 l-0.9-2.3l-0.9,1l0,0.4l0.6,1.5c0.1,0.3,0.4,0.4,0.6,0.4c0.1,0,0.2,0,0.3,0C18.8,17.6,18.9,17.2,18.8,16.9L18.8,16.9z M18.1,12.4 l-0.4-1.7c-0.1-0.4-0.4-0.8-0.8-0.9c-0.4-0.2-0.8-0.1-1.2,0.1c-0.5,0.3-0.8,0.7-1,1.3l-0.2,0.7L14.1,12v-2c0-0.2-0.2-0.3-0.3-0.3 h-3.4c-0.2,0-0.3,0.2-0.3,0.3v2l-0.3-0.2l-0.2-0.7c-0.2-0.5-0.5-1-1-1.3C8.1,9.6,7.7,9.6,7.3,9.8c-0.4,0.2-0.7,0.5-0.8,0.9l-0.4,1.7 c-0.1,0.4,0,0.9,0.3,1.2l1.4,1.6l0.2,2c0,0.3,0.3,0.6,0.7,0.6c0,0,0,0,0.1,0c0.4,0,0.6-0.4,0.6-0.7c0,0,0,0,0,0l-0.2-2 c0-0.3-0.1-0.5-0.3-0.7l-0.9-1l0.4-1.5l0.1,0.4c0.1,0.3,0.3,0.5,0.5,0.7l1.1,0.7c0.1,0.1,0.2,0.1,0.4,0.1h3.4c0.1,0,0.3,0,0.4-0.1 l1.1-0.7c0.2-0.2,0.4-0.4,0.5-0.7l0.1-0.4l0.4,1.5l-0.9,1c-0.2,0.2-0.3,0.5-0.3,0.7l-0.2,2c0,0.4,0.2,0.7,0.6,0.7c0,0,0,0,0.1,0 c0.3,0,0.6-0.3,0.7-0.6l0.2-2l1.4-1.6C18.1,13.3,18.2,12.9,18.1,12.4L18.1,12.4z M6.3,14.5l-0.9,2.3c-0.1,0.3,0,0.7,0.4,0.9 c0.3,0.1,0.7,0,0.9-0.4c0,0,0,0,0,0l0.6-1.5l0-0.4L6.3,14.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamworkBubble);
export default __webpack_public_path__ + "static/media/teamwork-bubble.1d1955d58df9b5dbc6ea3e156c1690e9.svg";
export { ForwardRef as ReactComponent };